import { api } from 'shared/api'
import { AiConversationFeedbackApiNew } from 'shared/api/requests/aiConversationFeedback/new'
import { AiConversationFeedbackSchemas } from 'shared/api/requests/aiConversationFeedback/schemas'

export const AiConversationFeedbackApi = {
  save: api.account.createPost({
    url: '/aiConversationFeedback/save',
    schemas: AiConversationFeedbackSchemas.save,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
  retrieve: api.account.createPost({
    url: '/aiConversationFeedback/retrieve',
    schemas: AiConversationFeedbackSchemas.retrieve,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
}

export { AiConversationFeedbackApiNew }
